/** File extensions (lowercase, no dot) renderable by an `<img>` tag. */
export const ACCEPTED_IMAGE_EXTENSIONS = [
  'bmp',
  'gif',
  'jpeg',
  'jpg',
  'jpe',
  'jfif',
  'png',
  'svg',
  'webp',
  'avif'
] as const;

/** File extensions (lowercase, no dot) renderable by a `<video>` tag. */
export const ACCEPTED_VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogv', 'mov', 'm4v'] as const;

/** File extensions (lowercase, no dot) renderable by an `<audio>` tag. */
export const ACCEPTED_AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg', 'oga', 'aac', 'm4a', 'flac', 'weba'] as const;

/** File extensions (lowercase, no dot) renderable by the browser's built-in PDF viewer. */
export const ACCEPTED_PDF_EXTENSIONS = ['pdf'] as const;
